module.exports = __webpack_public_path__ + "static/img/81.b8c64f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/81.png
// module id = hIHB
// module chunks = 1